import theme from '../../theme/theme';

const {
  colors: { white_text, blue_purple_button, divider },
} = theme;

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    background: blue_purple_button,
    minHeight: '4.625em',
    borderRadius: 0,
    borderTop: `0.063em solid ${divider}`,
  },

  goNow__text: {
    fontSize: '1.8em',
    textTransform: 'capitalize',
    color: white_text,
    fontFamily: 'semibold',
    letterSpacing: '-0.031em',
  },
};

export default styles;
